import { CookiesScreen } from "@/components/legalPolicies";
import MainLayout from "@/layouts/MainLayout";

const Cookies = () => {
  return (
    <MainLayout
      bgTheme="var(--background-light)"
      navbarTheme="light"
      title="Cookies Policy"
      description="Cookies is a page where the client can read the legal information about the product/services"
    >
      <CookiesScreen />
    </MainLayout>
  );
};

export default Cookies;
